export * from './characteristics';
export * from './faq';
export * from './review';
export * from './tabs';
export * from './video';
